//   যদি Database এ same page create করা হয়, তাহলে এই part ব্যবহার করা হবে। যদি না থাকে, তাহলে PageTemplate.js ফাইলটি ব্যবহার করা হবে।

//  import React from 'react';
//  import PageTemplate from './PageTemplate';
//  export default function FAQ(props) { return <PageTemplate {...props} slug="FAQ" />; }

import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';
import Header from '../Header';
import Footer from '../Footer';

const pb = new PocketBase('https://bahcarplaza.com');

function FAQ({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, setActiveTab }) {
  const [faqs, setFaqs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('');
  const [openFaqId, setOpenFaqId] = useState(null);
  const [loading, setLoading] = useState(true);

  // পেজ লোড হলে একেবারে উপরে স্ক্রল করবে
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // ডাটাবেস থেকে FAQ ফেচ করা
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        const records = await pb.collection('faqs').getFullList({ sort: 'sort_order' });
        setFaqs(records);

        if (records.length > 0) {
          const uniqueCategories = [...new Set(records.map(item => item.category))];
          setCategories(uniqueCategories);
          setActiveCategory(uniqueCategories[0]); 
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  const filteredFaqs = faqs.filter(faq => faq.category === activeCategory);

  const toggleFaq = (id) => {
    setOpenFaqId(openFaqId === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-[#f4f7f6] flex flex-col font-sans">
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
      
      <main className="flex-1 max-w-[1200px] w-full mx-auto py-12 px-6">
        
        {/* 🚨 Page Title & Branding 🚨 */}
        <div className="mb-10 text-center md:text-left">
          <h1 className="text-3xl md:text-4xl font-black text-[#002f34] uppercase tracking-tight">
            Frequently Asked <span className="text-[#ef5e33]">Questions</span>
          </h1>
          <p className="text-gray-500 font-bold mt-3 text-sm md:text-base">
            Welcome to the <strong className="text-[#002f34]">Bah! Car Plaza</strong> help center. Find everything you need to know about buying, selling, and inspecting cars with us at <a href="https://bahcarplaza.com" target="_blank" rel="noreferrer" className="text-[#ef5e33] hover:underline">https://bahcarplaza.com</a>.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-20 text-gray-500 font-bold text-xl">Loading FAQs...</div>
        ) : faqs.length === 0 ? (
          <div className="text-center py-20 text-gray-500 font-bold text-xl">No FAQs available right now.</div>
        ) : (
          <div className="flex flex-col md:flex-row gap-8 items-start">
            
            {/* LEFT SIDEBAR (Categories) */}
            <aside className="w-full md:w-1/3 lg:w-1/4 bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden sticky top-28">
              <div className="p-6 bg-gray-50 border-b border-gray-100">
                <h3 className="font-black text-[#002f34] uppercase text-sm tracking-wider">Help Topics</h3>
              </div>
              <ul className="flex flex-col">
                {categories.map((category, index) => (
                  <li 
                    key={index}
                    onClick={() => { setActiveCategory(category); setOpenFaqId(null); }}
                    className={`px-6 py-4 cursor-pointer font-bold text-sm transition-all duration-300 border-l-4 ${
                      activeCategory === category 
                        ? 'border-[#ef5e33] bg-[#fff3ec] text-[#ef5e33]' 
                        : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-[#002f34]'
                    }`}
                  >
                    {category}
                  </li>
                ))}
              </ul>
            </aside>

            {/* RIGHT CONTENT (Accordion Q&A) */}
            <div className="w-full md:w-2/3 lg:w-3/4 flex flex-col gap-4">
              
              <h2 className="text-2xl font-black text-[#002f34] mb-4 hidden md:block">
                {activeCategory}
              </h2>

              {filteredFaqs.map((faq) => (
                <div 
                  key={faq.id} 
                  className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300"
                >
                  <div 
                    onClick={() => toggleFaq(faq.id)}
                    className="flex justify-between items-center p-6 cursor-pointer select-none group"
                  >
                    <h3 className={`text-base font-black transition-colors duration-300 pr-4 ${openFaqId === faq.id ? 'text-[#ef5e33]' : 'text-[#002f34] group-hover:text-[#ef5e33]'}`}>
                      {faq.question}
                    </h3>
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-[#002f34] font-bold text-lg transition-transform duration-300">
                      {openFaqId === faq.id ? '−' : '+'}
                    </div>
                  </div>

                  <div 
                    className={`transition-all duration-500 ease-in-out overflow-hidden ${
                      openFaqId === faq.id ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div 
                      className="p-6 pt-0 text-gray-600 text-sm leading-relaxed border-t border-gray-50 mt-2"
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />
                  </div>
                </div>
              ))}

            </div>
          </div>
        )}

      </main>

      <Footer setView={setView} />
      
      {/* 🚨 Internal Custom CSS for Rich Text 🚨 */}
      <style>{`
        .leading-relaxed p { margin-bottom: 10px; }
        .leading-relaxed a { color: #ef5e33; font-weight: bold; text-decoration: underline; }
        .leading-relaxed ul { list-style-type: disc; padding-left: 20px; margin-bottom: 10px; }
        .leading-relaxed ol { list-style-type: decimal; padding-left: 20px; margin-bottom: 10px; }
        .leading-relaxed strong { color: #002f34; }
      `}</style>
    </div>
  );
}

export default FAQ;